export default "__VITE_ASSET__CfvtKCqy__"